<div
  class="v-one-floatlabel__container"
  [class.v-one-floatlabel__container--default]="variant() === 'default'"
  [class.v-one-floatlabel__container--on-border]="variant() === 'on-border'"
  [class.v-one-floatlabel__container--floating]="shouldFloat()"
  [class.v-one-floatlabel__container--focused]="isFocused()"
  [class.v-one-floatlabel__container--invalid]="invalid()"
>
  <ng-content></ng-content>
</div>
